import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Autocomplete,
  Typography,
  IconButton,
} from "@mui/material";
import AppButton from "../common/AppButton";
import { ColorPallet } from "../../utils/colorPallet";
import DeleteIcon from "../IconComp/deleteIcon";
import ToolTip from "../common/ToolTip";
import EditIcon from "../IconComp/editIcon";
import RedArrow from "../../assets/icon/sales_down_arrow.svg";
import { useAppDispatch } from "../../app/hooks";
import { getBatchData } from "../../features/batch/batchSlice";
import CheckoutScreen from "./checkoutScreen";
import LoadingSpinner from "../common/Loading";
import CustomAutocomplete from "../common/InputField/CustomAutocomplete";
import usePermissions from "../../hooks/usePermissions";
import BarcodeReader from "react-barcode-reader";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import CloseSVGIcon from "../IconComp/closeIcon";
import SaveIcon from "@mui/icons-material/Save";
import {
  BatchListHeaders,
  MedBatchHeaders,
  ProductHeaders,
  saleTypeDropDownOptions,
} from "../../utils/constants";

import { getMedicineBatchList } from "../../features/sales/salesSlice";
import WarningIcon from "../IconComp/warningIcon";
import WarningIconYellow from "../IconComp/warningIconYellow";
import NewSaleCheckout from "./newSaleCheckout";
import BatchListTable from "./BatchListTable";
import CalendarIcon from "../IconComp/calendar";

export const NewSaleEntry = (props) => {
  const {
    initialSalesData,
    handleCloseEditFunction,
    editInvoiceId,
    getSalesHistory,
    setOpenSnackbar,
  } = props;
  const initialDataExists = initialSalesData?.length > 0;

  const objectToPass = !initialDataExists
    ? []
    : initialSalesData?.map((item) => {
        return {
          medicine_name: item?.batch?.pharmacy_medicine?.name,
          dose: item?.batch?.pharmacy_medicine?.dose,
          quantity_boxes:
            (item?.batch?.quantity_sold / item?.batch?.unit_per_box)?.toFixed(
              2
            ) && "-",
          quantity_units: item?.batch?.quantity_sold,
          batch_id: item?.batch?.id,
          batchNo: item?.batch?.batch_no,
          quantity_to_be_sold: editInvoiceId
            ? item?.total_quantity_sold
            : item?.batch?.quantity_sold,
          sell_price: item?.batch?.sell_price,
          cost_price: item?.batch?.cost_price,
          amount_to_be_paid: item?.amount_to_be_paid,
          quantity: item?.batch?.quantity_sold,
          saleType: "Unit",
          id: item?.id,
        };
      });
  initialDataExists &&
    localStorage.setItem("editSalesData", JSON.stringify(objectToPass));
  const dispatch = useAppDispatch();
  const productionSelectedDate = new Date();
  const [filterData, setFilterData] = useState([]);
  const [medQuantity, setMedQuantity] = useState(" ");
  const [sortedBatchByDate, setSortedBatchByDate] = useState("");
  const [showCheckout, setShowCheckout] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isScannedBoolean, setScanBoolean] = useState(false);
  const [clearFields, setClearFields] = useState(false);
  const [selectedSaleType, setSelectedSaleType] = useState("Unit");
  const [salesData, setSalesData] = useState(() => {
    const savedSalesData = initialDataExists
      ? localStorage?.getItem("editSalesData")
      : localStorage?.getItem("salesData");
    return savedSalesData ? JSON?.parse(savedSalesData) : [];
  });

  const [batchData, setBatchData] = useState(null);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage?.getItem("pharmacy_account_type") || "0",
    10
  );
  const [medBarcode, setMedBarcode] = useState("");
  const [signalBarMed, setSignalBarMed] = useState("");
  const [medName, setMedName] = useState({ Name: "", dose: "" });
  const [medCdPrice, setMedCdPrice] = useState("");
  const [inputVal, setInputValue] = useState("");
  // New states for editing
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editQuantity, setEditQuantity] = useState("");
  const [medicineBatchesId, setMedicineBatchesId] = useState("");
  const [medicineBatchList, setMedicineBatchList] = useState([]);
  const [open, setOpen] = useState(false);
  const [showProductInfo, setShowProductInfo] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setMedicineBatchList([]);
    setMedicineBatchesId("");
    setShowProductInfo(false);
  };

  const total_quantity = medicineBatchList?.reduce(
    (total, item) => total + item?.quantity,
    0
  );

  const remaining_quantity = medicineBatchList?.reduce(
    (total, item) => total + item?.remaining_quantity,
    0
  );

  useEffect(() => {
    if (medicineBatchesId) {
      dispatch(
        getMedicineBatchList({
          medicine_id: medicineBatchesId,
          pharmacy_id: pharmacyId,
        })
      ).then((res) => {
        setMedicineBatchList(res?.payload);
        setOpen(true);
      });
    } else {
      setMedicineBatchList([]);
    }
  }, [medicineBatchesId, pharmacyId, dispatch]);

  // Existing useEffect and functions remain unchanged until the editing logic...
  const handleEditRow = (index) => {
    setIsEditing(true);
    setEditIndex(index);
    setEditQuantity(salesData[index]?.quantity_to_be_sold?.toString());
  };

  const handleSaveEdit = (index) => {
    const parsedEditQuantity = parseFloat(editQuantity);
    const currentEntry = salesData[index];
    const saleType = currentEntry?.saleType || "Unit"; // Default to "Unit" if not set

    if (isNaN(parsedEditQuantity) || parsedEditQuantity <= 0) {
      alert("Please enter a valid quantity");
      setMedQuantity("");
      setSelectedSaleType(selectedSaleType);
      return;
    }

    const medicineName = currentEntry?.medicine_name;
    // Get all batches for this medicine
    const relevantBatches = batchData?.payload?.batch_list
      ?.filter(
        (b) =>
          b?.pharmacy_medicine?.name === medicineName &&
          new Date(b?.expiry_date) >= new Date()
      )
      ?.sort((a, b) => new Date(a?.expiry_date) - new Date(b?.expiry_date));

    // Calculate total quantity already allocated to other entries (excluding current)
    const quantityInOtherEntries = salesData
      ?.filter((entry, i) => i !== index)
      ?.reduce((acc, entry) => {
        acc[entry?.batch_id] =
          (acc[entry?.batch_id] || 0) + entry?.quantity_to_be_sold;
        return acc;
      }, {});

    let remainingQtyToAllocate = parsedEditQuantity;
    const updatedSalesData = [...salesData?.filter((_, i) => i !== index)]; // Remove current entry

    // Process batches starting with the current one
    for (const batch of relevantBatches) {
      if (currentEntry?.saleType === "Box") {
        if (remainingQtyToAllocate % currentEntry?.quantity_units !== 0) {
          alert(
            `Enter appropriate unit number with respect to box size: ${currentEntry?.quantity_units}`
          );
          setMedQuantity("");
          setSelectedSaleType(selectedSaleType);
          return;
        }
      }
      if (remainingQtyToAllocate <= 0) break;

      const totalAvailable = batch?.quantity - batch?.quantity_sold;
      const usedByOthers = quantityInOtherEntries[batch?.id] || 0;
      const availableInBatch = Math.max(totalAvailable - usedByOthers, 0);
      const quantityBoxes = batch?.remaining_boxes
        ? batch?.remaining_boxes
        : batch?.total_box;
      const unitsPerBox = batch?.unit_per_box;
      const quantityUnits = unitsPerBox;

      if (availableInBatch > 0) {
        const qtyToAllocate = Math.min(
          remainingQtyToAllocate,
          availableInBatch
        );
        remainingQtyToAllocate -= qtyToAllocate;
        // Check if this batch already exists in updatedSalesData
        const existingEntryIndex = updatedSalesData?.findIndex(
          (e) => e?.batch_id === batch?.id && e?.medicine_name === medicineName
        );

        if (existingEntryIndex !== -1) {
          updatedSalesData[existingEntryIndex].quantity_to_be_sold +=
            qtyToAllocate;
          updatedSalesData[existingEntryIndex].amount_to_be_paid =
            updatedSalesData[existingEntryIndex].quantity_to_be_sold *
            updatedSalesData[existingEntryIndex].sell_price;
        } else {
          updatedSalesData.push({
            medicine_name: medicineName,
            quantity_boxes: quantityBoxes,
            quantity_units: quantityUnits,
            saleType: saleType,
            dose: currentEntry.dose,
            batch_id: batch.id,
            batchNo: batch.batch_no,
            quantity_to_be_sold: qtyToAllocate,
            sell_price: batch.sell_price,
            cost_price: batch.cost_price,
            amount_to_be_paid: qtyToAllocate * batch.sell_price,
            quantity: totalAvailable,
            sale_discount_percentage:
              currentEntry.sale_discount_percentage || 0,
            sale_discount_amount: currentEntry.sale_discount_amount || 0,
            amount_after_discount:
              currentEntry.amount_after_discount ||
              qtyToAllocate * batch.sell_price,
          });
        }
      }
    }

    // Check if we couldn't allocate all requested quantity
    if (remainingQtyToAllocate > 0) {
      alert(
        `Not enough stock available. The available quantity is only ${
          parsedEditQuantity - remainingQtyToAllocate
        }. `
      );
      setMedQuantity("");
      setSelectedSaleType(selectedSaleType);
      return;
    }

    // Recalculate discounts for all affected entries
    updatedSalesData.forEach((entry) => {
      const discountPercentage = entry.sale_discount_percentage || 0;
      const costAmount =
        (entry.cost_price || 0) * (entry.quantity_to_be_sold || 0);
      const discountAmount =
        (entry.amount_to_be_paid * discountPercentage) / 100;
      entry.sale_discount_amount = parseFloat(discountAmount.toFixed(2));
      entry.amount_after_discount =
        (entry.amount_to_be_paid || 0) - discountAmount;
    });

    setSalesData(updatedSalesData);
    initialDataExists
      ? localStorage.setItem("editSalesData", JSON.stringify(updatedSalesData))
      : localStorage.setItem("salesData", JSON.stringify(updatedSalesData));
    setIsEditing(false);
    setEditIndex(null);
    setEditQuantity("");
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditIndex(null);
    setEditQuantity("");
  };

  useEffect(() => {
    if (isScannedBoolean) {
      const timer = setTimeout(() => {
        if (!medName?.Name && medBarcode?.length > 0) {
          alert("Product Not Found Against Barcode");
          setMedBarcode("");
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isScannedBoolean, medName, medBarcode]);

  useEffect(() => {
    setMedName((prev) => {
      const newName = signalBarMed[0]?.pharmacy_medicine?.name || "";
      const newDose = signalBarMed[0]?.pharmacy_medicine?.dose || "";
      // Only update if values have changed to force re-render
      if (prev?.Name !== newName || prev?.dose !== newDose) {
        return { Name: newName, dose: newDose };
      }
      return prev; // No change, so avoid unnecessary re-renders
    });

    if (signalBarMed[0]?.pharmacy_medicine?.name) {
      setInputValue(signalBarMed[0]?.pharmacy_medicine?.name);
      document?.getElementById("quantityInput")?.focus();
    }
  }, [signalBarMed]);

  const handleScan = (data) => {
    if (data && data !== medBarcode) {
      setMedBarcode(data);
    }
    setScanBoolean(true);
  };

  const handleError = (err) => {
    console.error(err);
  };

  const fetchBatch = async () => {
    try {
      setIsLoading(true);
      const data = await dispatch(getBatchData({ pharmacy_id: pharmacyId }));
      setBatchData(data);
    } catch (error) {
      console.error("Error fetching batch data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchBatch();
  }, []);

  useEffect(() => {
    initialDataExists
      ? localStorage?.setItem("editSalesData", JSON?.stringify(salesData))
      : localStorage?.setItem("salesData", JSON?.stringify(salesData));
  }, [salesData]);

  const handleAddToList = () => {
    // --- Reset Fields ---
    setClearFields(false);
    setInputValue("");
    setMedBarcode("");

    // --- Basic Validation ---
    if (!medName?.Name && inputVal !== "") {
      alert("Product is not in stock");
      setClearFields(true);
      setMedQuantity("");
      document?.getElementById("quantityInput")?.blur();
      return;
    }

    if (!medName?.Name || !medQuantity) {
      alert("Please complete all fields");
      setClearFields(true);
      setMedQuantity("");
      setSelectedSaleType(selectedSaleType);
      document?.getElementById("quantityInput")?.blur();
      return;
    }

    if (!selectedSaleType) {
      alert("Select Sale Type Please");
      return;
    }

    // --- Prepare Batch Data ---
    const availableQuantities = filterData?.map((item) => ({
      batchId: item?.id,
      availableQuantity: item?.quantity - item?.quantity_sold,
      canBeBoxType: item?.total_box !== null || item?.remaining_boxes !== "-",
      total_box: item?.remaining_boxes ?? item?.total_box,
      unit_per_box: item?.unit_per_box,
    }));

    // Extract unit and box type info from the first batch (assumes all batches share the same unit structure)
    let isBoxType;
    let units;
    for (const batch of sortedBatchByDate || []) {
      const batchData = availableQuantities.find((b) => b.batchId === batch.id);
      if (batchData) {
        units = batchData.unit_per_box;
        isBoxType = batchData.canBeBoxType;
        break;
      }
    }
    // --- Parse Quantity ---
    let parsedQuantity;
    const inputQty = parseFloat(medQuantity);
    if (selectedSaleType === "Box" && isBoxType) {
      parsedQuantity = inputQty * units;
    } else if (selectedSaleType === "Unit" && isBoxType) {
      // if (inputQty % units !== 0) {
      //   alert(`Enter appropriate unit number with respect to box size: ${units}`);
      //   return;
      // }
      parsedQuantity = inputQty;
    } else if (!isBoxType && selectedSaleType === "Box") {
      alert("Select Unit Sale Type, as there are no Boxes");
      setMedQuantity("");
      setSelectedSaleType("Unit");
      return;
    } else {
      parsedQuantity = inputQty;
    }

    if (isNaN(parsedQuantity) || parsedQuantity <= 0) {
      alert("Please enter valid quantity");
      setClearFields(true);
      setMedQuantity("");
      setSelectedSaleType(selectedSaleType);
      document?.getElementById("quantityInput")?.blur();
      return;
    }

    // --- Calculate Total Available Stock ---
    const quantitySoldPerBatch = salesData?.reduce((acc, entry) => {
      acc[entry.batch_id] =
        (acc[entry.batch_id] || 0) + entry.quantity_to_be_sold;
      return acc;
    }, {});

    const totalAvailable = availableQuantities?.reduce((sum, batch) => {
      const remaining =
        batch.availableQuantity - (quantitySoldPerBatch[batch.batchId] || 0);
      return sum + Math.max(remaining, 0);
    }, 0);

    if (parsedQuantity > totalAvailable) {
      alert("Quantity exceeds available stock");
      setSelectedSaleType(selectedSaleType);
      setMedQuantity("");
      document?.getElementById("quantityInput")?.blur();
      return;
    }

    // --- Allocate Quantities Across Batches ---
    let remainingQty = parsedQuantity;
    const tempSalesData = [...salesData];

    for (const batch of sortedBatchByDate || []) {
      if (remainingQty <= 0) break;

      const batchData = availableQuantities.find((b) => b.batchId === batch.id);
      if (!batchData) continue;

      const { availableQuantity: batchAvailable, canBeBoxType } = batchData;

      const quantityBoxes = batch?.remaining_boxes ?? batch?.total_box;
      const unitsPerBox = batch.unit_per_box;

      const existingInSales = tempSalesData
        .filter((e) => e.batch_id === batch.id)
        .reduce((sum, e) => sum + e.quantity_to_be_sold, 0);

      let toAllocate = 0;

      if (
        selectedSaleType === "Unit" ||
        (selectedSaleType === "Box" && canBeBoxType)
      ) {
        const allocatable = Math.max(batchAvailable - existingInSales, 0);
        if (allocatable <= 0) continue;

        toAllocate = Math.min(remainingQty, allocatable);
      }

      remainingQty -= toAllocate;

      const existingIndex = tempSalesData.findIndex(
        (e) => e.batch_id === batch.id && e.medicine_name === medName.Name
      );

      if (existingIndex !== -1) {
        const existing = tempSalesData[existingIndex];
        existing.quantity_to_be_sold += toAllocate;
        existing.amount_to_be_paid =
          existing.quantity_to_be_sold * existing.sell_price;
        existing.saleType = isBoxType ? "Box" : "Unit";
      } else {
        tempSalesData.push({
          medicine_name: medName.Name,
          dose: medName.dose,
          quantity_boxes: quantityBoxes,
          quantity_units: unitsPerBox,
          batch_id: batch.id,
          batchNo: batch.batch_no,
          quantity_to_be_sold: toAllocate,
          sell_price: batch.sell_price,
          cost_price: batch.cost_price,
          amount_to_be_paid: toAllocate * batch.sell_price,
          quantity: batch.quantity - batch.quantity_sold,
          saleType: isBoxType ? "Box" : "Unit",
        });
      }
    }

    // --- Finalize ---
    setSalesData(tempSalesData);
    initialDataExists
      ? localStorage.setItem("editSalesData", JSON.stringify(tempSalesData))
      : localStorage.setItem("salesData", JSON.stringify(tempSalesData));
    setIsAdded(true);
    setMedName({ Name: "", dose: "" });
    setMedQuantity("");
    setSelectedSaleType("Unit");
    document?.getElementById("quantityInput")?.blur();
    setMedicineBatchList([]);
  };

  const handleDeleteRow = (index) => {
    const updatedSalesData = salesData?.filter((_, i) => i !== index);
    setSalesData(updatedSalesData);
  };

  // Other state and functions...

  const handleProceedToCheckout = () => {
    setShowCheckout(true);
  };

  const handleMedicineChange = (event) => {
    setIsAdded(false);
    setMedName({
      Name: event?.Name,
      dose: event?.dose,
    });
    setMedicineBatchesId(event?.id || "");
  };

  useEffect(() => {
    batchlist();
  }, [medName, medQuantity, medBarcode]);

  const batchlist = () => {
    if (medName?.Name && medQuantity) {
      const filteredBatches =
        batchData &&
        batchData?.payload?.batch_list?.filter((item) => {
          const remaining_quantity = item?.quantity - item?.quantity_sold;
          const expiryDate = new Date(item?.expiry_date);
          const currentDate = new Date();
          return (
            medName?.Name == item?.pharmacy_medicine?.name &&
            medName?.dose == item?.pharmacy_medicine?.dose &&
            remaining_quantity > 0 &&
            expiryDate >= currentDate
          );
        });
      setFilterData(filteredBatches);

      const batchsortedbydate = filteredBatches?.sort((a, b) => {
        const dateA = new Date(a?.expiry_date);
        const dateB = new Date(b?.expiry_date);
        return dateA?.getTime() - dateB?.getTime(); // Compare the dates numerically
      });
      const remainingQuantities = batchsortedbydate?.map((batch) => {
        const remaining_quantity = batch?.quantity - batch?.quantity_sold;
        return remaining_quantity;
      });
      // Sum up the remaining quantities using the reduce function
      const totalRemainingQuantity = remainingQuantities?.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setSortedBatchByDate(batchsortedbydate);
    }
  };
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (!batchData?.payload?.batch_list) return;
    const uniqueIdsSet = new Set();
    const validData = batchData?.payload?.batch_list?.filter((item) => {
      const expiryDate = new Date(item?.expiry_date);
      return (
        expiryDate >= new Date() &&
        !uniqueIdsSet?.has(item?.pharmacy_medicine?.id) &&
        uniqueIdsSet?.add(item?.pharmacy_medicine?.id)
      );
    });

    const barCodeData = validData?.filter(
      (item) => item?.pharmacy_medicine?.barcode === medBarcode
    );

    setSignalBarMed(barCodeData);
    setFilteredData(validData);
  }, [batchData, medBarcode, medCdPrice]);

  const handleChangeCode = (e) => {
    setScanBoolean(false);
    const value = e.target.value.trim(); // Trim spaces

    if (!value) {
      setSignalBarMed([]); // Reset filtered list
      setMedBarcode(""); // Clear barcode state
      return;
    }

    setMedBarcode(value); // Update state with the entered barcode
    setMedCdPrice(value); // Also update the input value state (this might be missing!)

    // Ensure `filteredData` exists before filtering
    if (filteredData?.length > 0) {
      const BarcodeInputValue = filteredData.filter(
        (item) => item?.pharmacy_medicine?.barcode?.toString() === value
      );

      setSignalBarMed(BarcodeInputValue);
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e); // Trim spaces);  // Update the parent's state with the new input value
    e?.length > 0 && setShowProductInfo(true);
  };

  // Function to handle discount percentage input
  const handleDiscountPercentageChange = (index, value) => {
    const newSalesData = [...salesData];
    let discountPercentage = parseFloat(value);

    // Prevent negative discount percentage
    if (discountPercentage < 0) {
      discountPercentage = 0;
      alert("Discount Percentage cannot be negative");
    }

    // Prevent discount percentage from being greater than 100
    if (discountPercentage > 100) {
      discountPercentage = 0; // Set the max discount percentage to 100
      alert("Discount Percentage cannot be greater than 100");
    }

    // Update discount for the selected medicine
    if (!isNaN(discountPercentage)) {
      const costAmount =
        (newSalesData[index]?.cost_price || 0) *
        (newSalesData[index]?.quantity_to_be_sold || 0);
      const totalAmount = newSalesData[index]?.amount_to_be_paid || 0; // Use 0 if undefined or null
      let discountAmount = (totalAmount * discountPercentage) / 100;

      // Round discount amount to 2 decimal places
      discountAmount = parseFloat(discountAmount.toFixed(2));

      // Round discount percentage to 2 decimal places
      discountPercentage = parseFloat(discountPercentage.toFixed(2));

      // Update discount amount and final payable amount
      newSalesData[index].sale_discount_percentage = discountPercentage;
      newSalesData[index].sale_discount_amount = discountAmount;
      const sellPriceAmount = newSalesData[index]?.amount_to_be_paid || 0;
      newSalesData[index].amount_after_discount = totalAmount - discountAmount;
    } else {
      // Reset discount values for invalid input
      newSalesData[index].sale_discount_percentage = 0;
      newSalesData[index].sale_discount_amount = 0;
      newSalesData[index].amount_after_discount =
        newSalesData[index].amount_to_be_paid || 0;
    }

    // Ensure all other medicines have 0 discount if no discount is set
    newSalesData?.forEach((item, idx) => {
      if (
        idx !== index && // Skip the currently updated item
        (item?.sale_discount_percentage === undefined ||
          item?.sale_discount_percentage === null)
      ) {
        const sellPriceAmount = item?.amount_to_be_paid || 0;
        const totalAmount = item?.amount_to_be_paid || 0;
        item.sale_discount_percentage = 0;
        item.sale_discount_amount = 0;
        item.amount_after_discount = totalAmount;
      }
    });

    // Update state and localStorage
    setSalesData(newSalesData);
    initialDataExists
      ? localStorage.setItem("editSalesData", JSON.stringify(newSalesData))
      : localStorage?.setItem("salesData", JSON?.stringify(newSalesData));
  };
  const handleSaleTypeChange = (event, value) => {
    setSelectedSaleType(value);
  };
  const handleDiscountAmountChange = (index, value) => {
    const newSalesData = [...salesData];
    let discountAmount = parseFloat(value);
    // Prevent negative discount amount
    if (discountAmount < 0) {
      alert("Discount Amount cannot be negative");
      discountAmount = 0;
    }
    // Get the cost amount (cost price * quantity) to calculate max discount
    const costAmount =
      (newSalesData[index]?.cost_price || 0) *
      (newSalesData[index]?.quantity_to_be_sold || 0);
    const totalAmount = newSalesData[index]?.amount_to_be_paid || 0;
    // Ensure discount amount is not greater than the total amount
    if (discountAmount > totalAmount) {
      alert("Discount Amount cannot be greater than Sell Price");
      discountAmount = 0; // Set discount amount to total amount if it exceeds
    }
    // Update discount amount for the selected medicine
    if (!isNaN(discountAmount)) {
      let discountPercentage = (discountAmount / totalAmount) * 100;

      // Round discount percentage to 2 decimal places
      discountPercentage = parseFloat(discountPercentage.toFixed(2));

      // Round discount amount to 2 decimal places
      discountAmount = parseFloat(discountAmount.toFixed(2));

      // Update discount percentage and final payable amount
      newSalesData[index].sale_discount_percentage = discountPercentage;
      newSalesData[index].sale_discount_amount = discountAmount;
      const sellPriceAmount = newSalesData[index]?.amount_to_be_paid || 0;
      newSalesData[index].amount_after_discount =
        sellPriceAmount - discountAmount;
    } else {
      // Reset discount values for invalid input
      newSalesData[index].sale_discount_percentage = 0;
      newSalesData[index].sale_discount_amount = 0;
      newSalesData[index].amount_after_discount =
        newSalesData[index].amount_to_be_paid || 0;
    }

    // Ensure all other medicines have 0 discount if no discount is set
    newSalesData?.forEach((item, idx) => {
      if (
        idx !== index && // Skip the currently updated item
        (item?.sale_discount_percentage === undefined ||
          item?.sale_discount_percentage === null)
      ) {
        const totalAmount = item?.amount_to_be_paid || 0;
        item.sale_discount_percentage = 0;
        item.sale_discount_amount = 0;
        item.amount_after_discount = totalAmount;
      }
    });

    // Update state and localStorage
    setSalesData(newSalesData);
    initialDataExists
      ? localStorage?.setItem("editSalesData", JSON?.stringify(newSalesData))
      : localStorage?.setItem("salesData", JSON?.stringify(newSalesData));
  };

  function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75vh", // Set height to full viewport height
          }}
        >
          <LoadingSpinner />
        </Box>
      ) : showCheckout ? (
        <NewSaleCheckout
          salesData={salesData}
          productionSelectedDate={productionSelectedDate}
          editInvoiceId={editInvoiceId}
          handleCloseEditFunction={handleCloseEditFunction}
          getSalesHistory={getSalesHistory}
          setOpenSnackbar={setOpenSnackbar}
        />
      ) : (
        <>
          <Box
            sx={{
              px: 2,
              py: 0,
              minHeight: {
                xs: "auto",
                sm: initialDataExists ? "auto" : "80vh",
              },

              my: "1.2%",
              mb: 3,
              mx: 2,
            }}
          >
            <Box sx={{}}>
              <TableContainer>
                <Table>
                  <TableHead
                    style={{
                      backgroundColor: ColorPallet?.tableHeaderColor,
                      marginTop: 5,
                      height: "40px",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ padding: "4px 16px" }}>
                        Product Name
                      </TableCell>
                      {/* <TableCell style={{ padding: '4px 8px' }}>Batch no.</TableCell> */}
                      <TableCell style={{ padding: "4px 16px" }}>
                        Bar Code
                      </TableCell>
                      <TableCell style={{ padding: "4px 16px" }}>
                        Sale Type
                      </TableCell>
                      {/* <TableCell style={{ padding: '4px 8px' }}>Amount(RS)</TableCell> */}
                      <TableCell style={{ padding: "4px 16px" }}>
                        Quantity
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "4px 16px",
                          textAlign: initialDataExists ? "right" : "center",
                        }}
                      >
                        {initialDataExists ? (
                          <IconButton
                            onClick={handleCloseEditFunction}
                            size="small"
                          >
                            <CloseSVGIcon />
                          </IconButton>
                        ) : (
                          "Action"
                        )}
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {(isPermissions?.view && Account_Type === 1) ||
                  Account_Type === 0 ? (
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ width: "36%" }}>
                          <CustomAutocomplete
                            defaultName={inputVal}
                            options={filteredData?.map((batch) => ({
                              Name: batch?.pharmacy_medicine?.name,
                              dose: batch?.pharmacy_medicine?.dose,
                              id: batch?.pharmacy_medicine?.id,
                            }))}
                            Value={
                              medName && Object?.keys(medName)?.length > 0
                                ? medName
                                : inputVal
                            }
                            handleAddToList={handleAddToList}
                            onChnage={(e) => {
                              handleMedicineChange(e);
                              // Move focus to the quantity input after selecting a medicine
                              if (e && e?.Name && inputVal) {
                                document
                                  .getElementById("quantityInput")
                                  ?.focus();
                              }
                            }}
                            onInputChange={(e) => {
                              handleInputChange(e);
                            }}
                            placeHolder="Enter Product Name"
                            isAdded={isAdded}
                            clearFields={clearFields}
                          />
                        </TableCell>

                        <TableCell>
                          <TextField
                            fullWidth
                            variant="outlined"
                            onChange={handleChangeCode}
                            value={medBarcode}
                            placeholder="Enter Barcode"
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "40px",
                                width: "100%",
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={saleTypeDropDownOptions}
                            value={selectedSaleType}
                            onChange={handleSaleTypeChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Sale Type"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "40px",
                                    width: {
                                      xs: "100px",
                                      sm: "100px",
                                      md: "200px",
                                    },
                                  },
                                }}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            fullWidth
                            id="quantityInput"
                            variant="outlined"
                            onChange={(e) => {
                              let value = e.target.value;
                              // Remove any non-digit and non-decimal characters
                              const cleaned = value.replace(/[^\d.]/g, "");
                              // Handle the decimal part
                              const parts = cleaned.split(".");
                              // If there are multiple decimal points, keep only the first one
                              if (parts.length > 1) {
                                const integerPart = parts[0];
                                const decimalPart = parts[1].slice(0, 2); // Keep only up to 2 decimal places
                                const newValue =
                                  integerPart + "." + decimalPart;
                                setMedQuantity(newValue);
                              } else {
                                setMedQuantity(cleaned);
                              }
                            }}
                            value={medQuantity}
                            placeholder="Enter quantity"
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "40px",
                                width: "100%",
                              },
                            }}
                            onKeyDown={(e) => {
                              if (e?.key === "Enter") {
                                if (medName?.Name) {
                                  handleAddToList();
                                }
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Tooltip
                            title={
                              filteredData?.length === 0
                                ? "Please add Batch First"
                                : ""
                            }
                            arrow
                          >
                            {/* span is needed because Tooltips don't work on disabled buttons directly */}
                            <span>
                              <AppButton
                                variant="contained"
                                color="primary"
                                onClick={handleAddToList}
                                title="Add to List"
                                sx={{
                                  textTransform: "none",
                                  width: "115px",
                                }}
                                disabled={filteredData?.length === 0}
                              />
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : null}
                </Table>
              </TableContainer>
              {(isPermissions?.view && Account_Type === 1) ||
              Account_Type === 0 ? (
                <>
                  {/** Batches List start*/}
                  <Box sx={{ position: "relative" }}>
                    {medicineBatchList?.length > 0 && open && (
                      <Box
                        sx={{
                          position: "absolute", // Makes it float
                          top: -2,
                          left: 0,
                          width: "100%", // or a fixed width if needed
                          zIndex: 10, // Stays above other content
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          p: 2,
                          boxShadow: 3,
                          backgroundColor: "#fff",
                        }}
                      >
                        {/* Close Button */}
                        <IconButton
                          size="small"
                          sx={{
                            position: "absolute",
                            top: 2,
                            right: 8,
                            zIndex: 20,
                            color: "#000000",
                          }}
                          onClick={handleClose}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>

                        {/* Medicine Summary Table */}
                        <TableContainer>
                          <Table
                            sx={{
                              mt: 3,
                              width: "100%",
                              minWidth: 650,
                              overflowX: "auto",
                            }}
                            stickyHeader
                          >
                            <TableHead sx={{ backgroundColor: "#F0F1F5" }}>
                              <TableRow>
                                {MedBatchHeaders.map((item) => (
                                  <TableCell
                                    sx={{
                                      border: `1px solid ${ColorPallet.borderColor}`,
                                      paddingY: "2px !important",
                                      paddingLeft: "8px !important",
                                    }}
                                  >
                                    {item.title}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              <TableRow>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {medName.Name} {medName.dose}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {total_quantity}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {remaining_quantity?.toFixed(2)}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Batches List */}
                        {showProductInfo && (
                          <BatchListTable
                            medicineBatchList={medicineBatchList}
                            WarningIcon={WarningIcon}
                            WarningIconYellow={WarningIconYellow}
                            ColorPallet={ColorPallet}
                            BatchListHeaders={BatchListHeaders}
                          />
                        )}
                      </Box>
                    )}
                  </Box>

                  {/** Batches List end*/}

                  <Box sx={{ mt: 0, px: 0.5 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#1A202C",
                        color: "#fff",
                        justifyContent: "space-between",
                        padding: "8px",
                        px: 2,
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      <Typography>
                        {initialDataExists
                          ? "Sales Items List"
                          : "Purchased Items List"}
                      </Typography>
                      {initialDataExists && (
                        <Typography
                          sx={{ display: "flex", alignItems: "center", gap: 0 }}
                        >
                          <IconButton>
                            <CalendarIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                          {formatDate(initialSalesData?.[0]?.created_at)}
                        </Typography>
                      )}
                    </Box>

                    <TableContainer
                      sx={{
                        maxHeight: {
                          xs: 300,
                          sm: 400,
                          md: 350,
                          lg: 600,
                          xl: 700,
                        },
                        "@media (min-width:820px) and (max-width:900px)": {
                          maxHeight: 550,
                        },
                        "@media (min-width:1023px) and (max-width:1050px)": {
                          maxHeight: 210,
                        },
                        "@media (min-width:1200px) and (max-width:1280px)": {
                          maxHeight: 400,
                        },
                        overflowY: "auto",
                        overflowX: "auto",
                        minWidth: { xs: "100%", sm: "600px" },
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            {ProductHeaders?.map((item, index) => (
                              <TableCell
                                sx={{
                                  border: `1px solid ${ColorPallet?.borderColor}`,
                                  paddingY: "2px !important",
                                  paddingLeft: "8px !important",
                                }}
                                key={index}
                              >
                                {item.title}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {salesData?.length > 0 ? (
                            salesData?.map((entry, index) => (
                              <TableRow key={index}>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {/* {entry && entry.medicine_name && entry.dose ? `${entry.medicine_name} ${entry.dose}` : ''} */}
                                  {entry &&
                                  entry?.medicine_name &&
                                  entry?.dose ? (
                                    <span>
                                      {entry?.medicine_name}{" "}
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          position: "relative",
                                          bottom: 9,
                                          right: 1,
                                        }}
                                      >
                                        {entry?.dose}
                                      </span>
                                    </span>
                                  ) : (
                                    <span>
                                      {entry?.medicine_name}{" "}
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          position: "relative",
                                          bottom: 9,
                                          right: 1,
                                        }}
                                      >
                                        {entry?.dose}
                                      </span>
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.batchNo}
                                </TableCell>
                                {/* <TableCell
                                sx={{
                                  border: `1px solid ${ColorPallet?.borderColor}`,
                                }}
                              >
                                {entry?.quantity_to_be_sold?.toFixed(2)}
                              </TableCell> */}
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.saleType === "Box" &&
                                    (
                                      entry?.quantity_to_be_sold /
                                      entry?.quantity_units
                                    ).toFixed(2)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.quantity_to_be_sold}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {isEditing && editIndex === index ? (
                                    <TextField
                                      value={editQuantity}
                                      onChange={(e) => {
                                        setEditQuantity(e.target.value);
                                      }}
                                      type="number"
                                      size="small"
                                      sx={{ width: "80px" }}
                                      inputProps={{ min: 0 }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          handleSaveEdit(index);
                                        }
                                      }}
                                    />
                                  ) : (
                                    <>{entry?.quantity_to_be_sold}</>
                                  )}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.cost_price?.toFixed(2)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.sell_price?.toFixed(2)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {entry?.amount_to_be_paid?.toFixed(2)}
                                </TableCell>

                                {/* Cell for Discount Amount */}
                                {/* New Cell for Discount Percentage */}
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "4px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  <TextField
                                    value={
                                      entry?.sale_discount_percentage || ""
                                    }
                                    onChange={(e) =>
                                      handleDiscountPercentageChange(
                                        index,
                                        e?.target?.value
                                      )
                                    }
                                    placeholder="Discount(%)"
                                    type="number"
                                    size="small"
                                  />
                                </TableCell>

                                {/* New Cell for Discount Amount */}
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "4px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  <TextField
                                    value={entry?.sale_discount_amount || ""}
                                    onChange={(e) =>
                                      handleDiscountAmountChange(
                                        index,
                                        e?.target?.value
                                      )
                                    }
                                    placeholder="Discount Amount"
                                    type="number"
                                    size="small"
                                  />
                                </TableCell>

                                {/* Cell for Final Amount to be Paid */}
                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {entry?.amount_after_discount
                                      ? entry?.amount_after_discount.toFixed(2)
                                      : entry?.amount_to_be_paid.toFixed(2)}
                                    {entry?.sale_discount_amount >
                                      entry?.cost_price *
                                        entry?.quantity_to_be_sold && (
                                      <Box
                                        sx={{
                                          width: "80%",
                                          display: "flex",
                                          margin: "5px",
                                          justifyContent: "space-around",
                                          alignItems: "center",
                                        }}
                                      >
                                        <ToolTip
                                          height={"10px"}
                                          IconType={RedArrow}
                                          title={`After Applying Discount Value, Loss will be ${(
                                            entry?.sale_discount_amount -
                                            entry?.cost_price *
                                              entry?.quantity_to_be_sold
                                          ).toFixed(2)} Rs`}
                                          style={{ cursor: "pointer" }}
                                        />
                                        <Box
                                          sx={{
                                            color: ColorPallet.errorText,
                                            fontWeight: "500",
                                            fontSize: "10px",
                                          }}
                                        >
                                          {(
                                            entry?.sale_discount_amount -
                                            entry?.cost_price *
                                              entry?.quantity_to_be_sold
                                          ).toFixed(2)}{" "}
                                          Rs
                                        </Box>
                                      </Box>
                                    )}
                                  </Box>
                                </TableCell>

                                {/* <TableCell
                                sx={{
                                  border: `1px solid ${ColorPallet?.borderColor}`,
                                  cursor: "pointer",
                                }}
                              >
                                <DeleteIcon
                                  onClick={() => handleDeleteRow(index)}
                                />
                              </TableCell> */}

                                <TableCell
                                  sx={{
                                    border: `1px solid ${ColorPallet?.borderColor}`,
                                    cursor: "pointer",
                                    paddingY: "2px !important",
                                    paddingLeft: "8px !important",
                                  }}
                                >
                                  {isEditing && editIndex === index ? (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Tooltip title="Save" arrow>
                                          <IconButton
                                            onClick={() =>
                                              handleSaveEdit(index)
                                            }
                                            size="small"
                                          >
                                            <SaveIcon
                                              fontSize="small"
                                              style={{
                                                color: "#02BE8E",
                                                marginRight: "-6px",
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Cancel" arrow>
                                          <IconButton
                                            onClick={handleCancelEdit}
                                            size="small"
                                          >
                                            <CloseIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Tooltip title="Edit" arrow>
                                          <IconButton
                                            onClick={() => handleEditRow(index)}
                                            size="small"
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete" arrow>
                                          <IconButton
                                            onClick={() =>
                                              handleDeleteRow(index)
                                            }
                                            size="small"
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={12}
                                align="center"
                                style={{
                                  height: "50vh",
                                }}
                              >
                                No Data Found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </>
              ) : null}
              <BarcodeReader onError={handleError} onScan={handleScan} />
            </Box>

            {(isPermissions?.add && Account_Type === 1) ||
            Account_Type === 0 ? (
              <Box sx={{ mt: 3 }}>
                {salesData?.length > 0 && (
                  <AppButton
                    variant="contained"
                    color="primary"
                    title="Proceed to Checkout"
                    sx={{ float: "right", textTransform: "none" }}
                    onClick={handleProceedToCheckout}
                  />
                )}
              </Box>
            ) : null}
          </Box>
        </>
      )}
    </>
  );
};
